<footer
  class="axis-footer"
  role="contentinfo"
>
  <div class="axis-footer-container _ptb-xxlarge">
    <ul class="axis-list-inline custom-footer">
      <!-- <li>
        <a
          href="javascript:void(0);"
          target="_blank"
          >User Agreement</a
        >
      </li> -->
      <li>
        <a
          href="https://www.aig.com/terms-of-use"
          target="_blank"
          >Terms Of Use</a
        >
      </li>
      <li>
        <a
          href="https://www.aig.com/cookie-policy"
          target="_blank"
          >Cookie Policy</a
        >
      </li>
      <li>
        <a
          href="https://www.aig.com/privacy-policy"
          target="_blank"
          >Privacy</a
        >
      </li>
      <li>
        <a
          href="https://www.aig.com/california-consumer-privacy-act-notice"
          target="_blank"
          >Do Not Sell or Share My Personal Information</a
        >
      </li>
      <li>
        <a
          href="https://www.aig.com/legal-notice"
          target="_blank"
          >Legal Notice</a
        >
      </li>
      <li>
        <a
          href="https://www.aig.com/enterprise-resilience-disclosure"
          target="_blank"
          >Enterprise Resilience</a
        >
      </li>
      <li>
        <a
          href="https://www.aig.com/"
          target="_blank"
          >aig.com</a
        >
      </li>
    </ul>
    <p class="axis-footer-copyright">
      Copyright &copy;

      1997-{{ dateTime.addDays("0") | date: "yyyy" }} American International Group, Inc. All rights reserved.
    </p>

    <p class="axis-footer-copyright _hidden-print">
      American International Group, Inc. (NYSE: AIG) is a leading global insurance organization. AIG provides insurance
      solutions that help businesses and individuals in more than 200 countries and jurisdictions protect their assets
      and manage risks through AIG operations, licenses and authorizations as well as network partners. For additional
      information, visit<a
        target="_blank"
        href="https://www.aig.com/"
      >
        www.aig.com </a
      >. This website with additional information about AIG has been provided as a convenience, and the information
      contained on such website is not incorporated by reference herein.
    </p>
    <p class="axis-footer-copyright _hidden-print">
      AIG is the marketing name for the worldwide operations of American International Group, Inc. All products and
      services are written or provided by subsidiaries or affiliates of American International Group, Inc. Products or
      services may not be available in all countries and jurisdictions, and coverage is subject to underwriting
      requirements and actual policy language. Non-insurance products and services may be provided by independent third
      parties. Certain property casualty coverages may be provided by a surplus lines insurer. Surplus lines insurers do
      not generally participate in state guaranty funds, and insureds are therefore not protected by such funds.
    </p>
  </div>
</footer>
